/**
 * Visual phone component
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import phoneImage from '../../assets/iphone.svg'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  left: ${props => props.needOffset ? '-20%' : '0%'};
  transition: all 0.15s;
  ${props => props.wrapperRawStyle}
`
const Container = styled.div`
  height: 100%;
  text-align: center;
`
const InnerWrapper = styled.div`
  margin: 0 auto;
  position: absolute;
  top: 13.5%;
  left: 7.5%;
  right: 7.5%;
  bottom: 14.5%;
`
const Content = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
`
const FieldsContainer = styled.div`
  margin-left: -8%;
  position: absolute;
  top: 0;
  left: 0;
`

class Phone extends Component {

  constructor () {
    super()

    this.state = {
      width: 0,
      imgHeight: 0
    }
  }

  componentDidMount () {
    this.htmlElement = document.querySelector('html')

    window.addEventListener('resize', this.updateContent)
    this.imgRef.addEventListener('load', this.updateContent)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateContent)
    this.imgRef.removeEventListener('load', this.updateContent)
  }

  updateContent = () => {
    if (this.imgRef && this.wrapper) { // Content takes 85% of phone's width
      const h = this.wrapper.getBoundingClientRect().height
      this.setState({imgHeight: h}, () => {
        this.setState({ width: Math.round(this.imgRef.getBoundingClientRect().width * 0.85) })
      })
    }

    if (this.imgRef && this.htmlElement) { // Adjust html's font size for correct IA's styling
      //this.htmlElement.style.fontSize = this.imgRef.getBoundingClientRect().width / 70 + 'px'
      this.htmlElement.style.fontSize = this.imgRef.getBoundingClientRect().width * 0.85 * 16 / 9 * 0.01 + 'px'
    }
  }

  render () {
    const { children, fields, needOffset, wrapperRawStyle } = this.props

    return (
      <Wrapper needOffset={needOffset} innerRef={ref => (this.wrapper = ref)} wrapperRawStyle={wrapperRawStyle}>
        <Container>
          <img src={phoneImage} style={{ width: 'auto', height: this.state.imgHeight, userSelect: 'none' }} ref={ref => (this.imgRef = ref)} />
          <InnerWrapper style={{ width: this.state.width }}>
            <Content>
              {children}
            </Content>
            <FieldsContainer>
              {fields}
            </FieldsContainer>
          </InnerWrapper>
        </Container>
      </Wrapper>
    )
  }
}

Phone.defaultProps = {
  needOffset: true,
  wrapperRawStyle: ''
}

Phone.propTypes = {
  fields: PropTypes.element, // Component to display field labels attached to left side of phone
  needOffset: PropTypes.bool,
  wrapperRawStyle: PropTypes.string
  // isEditorPopoverVisible: PropTypes.bool,
}

export default Phone



// WEBPACK FOOTER //
// ./src/components/shared/Phone.js